import axios from 'axios';

import { CacheService } from '../services/Cache.Service';

import { IAlertOnboard } from '../common/Types';

const cacheTtlInMs = 6000;

export const AlertOnboardService = {
  getAll: async (
    authToken: string,
    forceRefresh: boolean = false):
    Promise<IAlertOnboard[]> => {
    const response = await CacheService.getAndUpdate(
      authToken,
      'IDLSignalSources',
      cacheTtlInMs,
      forceRefresh);
    console.log(response);
    return response as IAlertOnboard[];
  },

  get: async (
    authToken: string,
    scenarioName: string,
    forceRefresh: boolean = false):
    Promise<IAlertOnboard | null> => {
    const response = await CacheService.getAndUpdate(
      authToken,
      'IDLSignalSources/' + scenarioName,
      cacheTtlInMs,
      forceRefresh);
    return response as IAlertOnboard;
  },

  create: async (
    authToken: string,
    signalSourceShortName: string,
    items: IAlertOnboard[]):
    Promise<IAlertOnboard[] | undefined> => {
    const endpoint = 'IDLSignalSources';
    const headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + authToken
    };

    try {
      const apiresult = await axios.post(
        process.env.REACT_APP_PORTAL_API_ENDPOINT + '/api/' + endpoint,
        items,
        { headers: headers }
      );

      return apiresult.data as IAlertOnboard[];
    } catch (err) {
      console.log(err);
      return undefined;
    }
  },

  createOrUpdate: async (
    authToken: string,
    signalSourceShortName: string,
    items: IAlertOnboard[]):
    Promise<IAlertOnboard[] | undefined> => {
    const endpoint = 'IDLSignalSources';
    const headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + authToken
    };

    try {
      const apiresult = await axios.put(
        process.env.REACT_APP_PORTAL_API_ENDPOINT + '/api/' + endpoint,
        items,
        { headers: headers }
      );

      return apiresult.data as IAlertOnboard[];
    } catch (err) {
      console.log(err);
      return undefined;
    }
  },

  createOrUpdateDev: async (
    authToken: string,
    signalSourceShortName: string,
    items: IAlertOnboard[]):
    Promise<IAlertOnboard[] | undefined> => {
    const endpoint = 'IDLSignalSources';
    const headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + authToken
    };

    try {
      const apiresult = await axios.put(
        process.env.REACT_APP_PORTAL_API_ENDPOINT_DEV + '/api/' + endpoint,
        items,
        { headers: headers }
      );

      return apiresult.data as IAlertOnboard[];
    } catch (err) {
      console.log(err);
      return undefined;
    }
  },

  patch: async (authToken: string, scenarioName: string, patchBody: string) => {
    const endpoint = 'IDLSignalSources/' + scenarioName;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + authToken
    };

    try {
      const apiresult = await axios.patch(
        process.env.REACT_APP_PORTAL_API_ENDPOINT + '/api/' + endpoint,
        patchBody,
        { headers: headers }
      );

      return (apiresult.data as IAlertOnboard);
    } catch (err) {
      console.log(err);
      return undefined;
    }
  },

  validatekqlquery: async (
    authToken: string,
    kqlquery: string):
    Promise<boolean | null> => {
    const endpoint = 'IDLQuery';
    const headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + authToken
    };

    try {
      const apiresult = await axios.post(
        process.env.REACT_APP_PORTAL_API_ENDPOINT + '/api/' + endpoint,
        kqlquery,
        { headers: headers }
      );

      return (apiresult.status >= 200 && apiresult.status < 300);
    } catch (err) {
      console.log(err);
      return false;
    }
  }
};
